
<ng-container *ngIf="!( isUsuarioExterno$ | async )">
	<section class="info-section">
		<self-service></self-service>
	</section>

	<hr>
</ng-container>

<section class="info-section">
	<menu-comedor></menu-comedor>
</section>

<!-- <hr>

<section class="info-section">
	<pizarra></pizarra>
</section> -->

<!--
<hr>

<section class="info-section">
	<evento></evento>
</section>
-->
